export default {
  holidayplanname: {
    dependent: '',
    header: 'Name & Description',
    headercss: 'vmHeader',
    subheader: 'Holiday Plan Name',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  description: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'Breif description about this holiday plan',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  holidayyear: {
    dependent: '',
    header: 'Holiday Preferences',
    headercss: 'vmHeader',
    subheader: 'For which year are you creating these holiday preferences?',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  isrequiremandatory: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'Employees get mandatory holidays',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  isrequireoptional: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'Employees get optional holidays',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },
  holidayplan: {
    dependent: '',
    header: 'Plan',
    headercss: 'vmHeader',
    subheader: 'Plan',
    subheadercss: 'vmSubHeader',
    values: '',
  },
  holiday: [{
    holidayname: {
      dependent: '',
      header: 'Plan',
      headercss: 'vmHeader',
      subheader: 'Holiday Name',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
    holidaydate: {
      dependent: '',
      header: '',
      headercss: 'vmHeader',
      subheader: 'Holiday Date',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
    ismandatory: {
      dependent: '',
      header: '',
      headercss: 'vmHeader',
      subheader: 'Is mandatory or optional?',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
  },
  {
    holidayname: {
      dependent: '',
      header: '----------------------',
      headercss: 'vmHeader',
      subheader: 'Holiday Name',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
    holidaydate: {
      dependent: '',
      header: '',
      headercss: 'vmHeader',
      subheader: 'Holiday Date',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
    ismandatory: {
      dependent: '',
      header: '',
      headercss: 'vmHeader',
      subheader: 'Is mandatory or optional?',
      subheadercss: 'vmSubHeader',
      values: '<val>',
    },
  }],
  lastdateexistingemp: {
    dependent: '',
    header: 'Approval',
    headercss: 'vmHeader',
    subheader: 'By which date should the employee select his/her optional holidays?',
    subheadercss: 'vmSubHeader',
    values: 'Existing Employees On <val>',
  },
  isnotifyexisting: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: '',
    subheadercss: 'vmSubHeader',
    values: 'If not selected then send email notification to manager',
  },
  dayfornewemp: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: '',
    subheadercss: 'vmSubHeader',
    values: 'New Employees Within  <val> Days Of Joining',
  },
  isnotifynew: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'If not selected then',
    subheadercss: 'vmSubHeader',
    values: 'Send email notification to manager',
  },

  maxoptlimit: {
    dependent: '',
    header: '',
    headercss: 'vmHeader',
    subheader: 'What are the maximum number of optional holidays from the available optional holiday list can select ?	',
    subheadercss: 'vmSubHeader',
    values: '<val>',
  },

};
